import { Departamento, DepartamentosAllResponse } from "app/types/configuracion/departamentos";
import { toaster } from "app/utilities/commons";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_NET;

export async function getAllDepartments(page: number | string, pageSize: number | string) {
  try {
    const response = await axios.get<DepartamentosAllResponse>(`${API_URL}Department?Page=${page}&PageSize=${pageSize}`);
    return response.data.data;
  } catch (err) {
    console.error("Error:", err);
    throw err;
  }
}

export async function getAllDepartmentsFilter(page: number | string, pageSize: number | string, name?: string, description?: string) {
  let response;
  try {
    response = await axios.get<DepartamentosAllResponse>(`${API_URL}Department?Name=${name}&Page=${page}&PageSize=${pageSize}`);
    console.log("NAME FILTER ", response.data.data);
    return response.data.data;
  } catch (err) {
    console.error("Error fetching Department");
    throw err;
  }
}

export async function getAllDepartmentsFilterDesc(page: number | string, pageSize: number | string, description?: string) {
  let response;
  try {
    response = await axios.get<DepartamentosAllResponse>(`${API_URL}Department?Description=${description}&Page=${page}&PageSize=${pageSize}`);
    console.log("DESCRIPTION FILTER", response.data.data);
    return response.data.data;
  } catch (err) {
    console.error("Error fetching Department");
    throw err;
  }
}

export async function departmentCreateAndUpdate(body: Departamento) {
  let response;
  const {
    idCompany,
    name, description,
    bonusCalculation, commissionCalculation,
    idUserAuthorization, idUserSolicitor,
    id
  } = body;

  if (id) {
    try {
      response = await axios.put(`${API_URL}Department/${id}`, {
        idCompany,
        name,
        description,
        bonusCalculation,
        commissionCalculation,
        idUserAuthorization,
        idUserSolicitor,
        id
      });

      toaster.success('Se cambio con éxito la información');
      return response.data;
    } catch (err: any) {
      err.response?.data?.errors.forEach((msg: any) => {
        toaster.error(msg.message)
      });
      console.error("ERROR UPDATING Department: ", err);
      throw err;
    }
  } else {
    try {
      response = await axios.post(`${API_URL}Department`, {
        idCompany,
        name,
        description,
        bonusCalculation,
        commissionCalculation,
        idUserAuthorization,
        idUserSolicitor
      })
      toaster.success("Guardado correctamente");
      return response.data;
    } catch (err: any) {
      err.response?.data?.errors.forEach((msg: any) => {
        toaster.error(msg.message)
      });
      console.error("ERROR CREATING Department: ", err);
      throw err;
    }
  }
}